import React, {Component} from 'react';
import {DashboardFilters} from "./DashboardFilters";
import {DashboardConfig} from "../../utils/DashboardConfig";
import DemoButton from "../buttons/DemoButton";

export class DashboardHeader extends Component {
    constructor(props) {
        super(props);
        this._dashboardConfig = new DashboardConfig();
        this.state = {
            filters: this.props.filters
        }
    }

    componentDidUpdate(prevProps) {
        // Verificar si cada propiedad relevante ha cambiado
        if (prevProps.filters !== this.props.filters) {
            this.setState({ filters: this.props.filters });
        }
    }

    render() {
        return (
            <header className="section-header">
                {/*202306: No se muestra más acá sino que en cada fila/presupuesto <DashboardGeneralAlerts />*/}
                <DemoButton />
                <div className="header-dashboard">
                    <DashboardFilters
                        textFilter={this.state.filters.textFilter}
                        issuesOnly={this.state.filters.issuesOnly}
                        labelsFilter={this.state.filters.labelsFilter}
                        platformFilter={this.state.filters.platformFilter}
                        availablePlatforms={this.props.availablePlatforms}
                        hiddenColumns={this.props.hiddenColumns}
                        onHiddenColumnsChange={this.props.onHiddenColumnsChange}
                        onTextFilterChange={this.props.onTextFilterChange}
                        onPlatformFilterChange={this.props.onPlatformFilterChange}
                        onToggleIssuesOnly={this.props.onToggleIssuesOnly}
                        onLabelsFilterChange={this.props.onLabelsFilterChange}
                        activeColumns={this.props.activeColumns}
                        activeColumnsSetId={this.props.activeColumnsSetId}
                        handleColumnStateChange={this.props.handleColumnStateChange}
                        onColumnsPositionChange={this.props.onColumnsPositionChange}
                        columnsSets={this.props.columnsSets}
                        onSelectColumnSet={this.props.onSelectColumnSet}
                        onSaveColumnSet={this.props.onSaveColumnSet}
                        onDeleteColumnSet={this.props.onDeleteColumnSet}
                        onDownloadDashboardData={this.props.onDownloadDashboardData}
                        isDownloading={this.props.isDownloading}
                        flexIndicators={this.props.flexIndicators}
                        ga4Indicators={this.props.ga4Indicators}
                        ecommerceIndicators={this.props.ecommerceIndicators}
                        paidMediaIndicators={this.props.paidMediaIndicators}
                        metaIndicators={this.props.metaIndicators}
                        canEditFlexIndicators={this.props.canEditFlexIndicators}
                        moduleInsightsEnabled={this.props.moduleInsightsEnabled}
                        bulkUserBusinessUnitsSyncEnabled={this.props.bulkUserBusinessUnitsSyncEnabled}
                        onSyncAllBusinessUnits={this.props.onSyncAllBusinessUnits}
                    />
                </div>
            </header>
        )
    }
}

